import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faLanguage } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Breadcrumbs from "../../Navigation/Components/Breadcrumbs";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";
import axios from "axios";

import "./EditBehaviorForm.css";

function EditBehaviorForm() {
  const [isLoading, setIsLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [title_english, setTitleEnglish] = useState("");
  const [description_english, setDescriptionEnglish] = useState("");
  const [competency, setCompetency] = useState("");
  const [scale, setScale] = useState("");
  const [scales, setScales] = useState([]);
  const [competencies, setCompetencies] = useState([]);
  const [english, setEnglish] = useState(false);

  const { state } = useContext(AuthContext);

  const navigate = useNavigate();

  let { bid } = useParams();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/competencies/behavior/${bid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      const result = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/behaviors/organization/create/${state.organization}`,
        data: { language: state.language },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setScales(result.data.scales);
      setCompetencies(result.data.competencies);
      setTitle(response.data.behavior.title);
      setTitleEnglish(response.data.behavior.title_english);
      setDescription(response.data.behavior.description);
      setDescriptionEnglish(response.data.behavior.description_english);
      setCompetency(response.data.competency._id);
      setScale(response.data.behavior.scale);

      if (state.language === "en") {
        setEnglish(true);
      } else {
        setEnglish(false);
      }

      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.organization, state.language, bid]);

  const handleNameChange = (e) => {
    setTitle(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleTitleEnglishChange = (e) => {
    setTitleEnglish(e.target.value);
  };

  const handleDescriptionEnglishChange = (e) => {
    setDescriptionEnglish(e.target.value);
  };

  const activateEnglish = () => {
    setEnglish(true);
  };

  const handleCompetencyChange = (e) => {
    setCompetency(e.target.value);
  };

  const handleScaleChange = (e) => {
    setScale(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/behaviors/${bid}`,
        data: {
          title: title,
          title_english: title_english,
          description: description,
          description_english: description_english,
          competency: competency,
          scale: scale,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/behaviors");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  let breadcrumbs = [
    {
      title: state.language === "es" ? "Comportamientos" : "Behaviors",
      path: "/behaviors",
    },
  ];

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Breadcrumbs data={breadcrumbs} />
        </Row>
        <Row>
          <Col className="edit-behavior-header">
            <h2>
              {t("Competencias.Comportamiento.EditForm.EditarComportamiento")}
            </h2>
          </Col>
          <Col lg={1} className="new-scale-header mb-2">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={activateEnglish}>
                  <FontAwesomeIcon icon={faLanguage} /> English
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          <Col className="edit-behavior-form">
            <Form>
              <FloatingLabel label="Título" className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Título"
                  onChange={handleNameChange}
                  value={title}
                />
              </FloatingLabel>
              {english ? (
                <FloatingLabel label="Title" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Title"
                    onChange={handleTitleEnglishChange}
                    value={title_english}
                  />
                </FloatingLabel>
              ) : (
                <></>
              )}
              <FloatingLabel className="mb-3" label="Descripción">
                <Form.Control
                  as="textarea"
                  placeholder="Descripción"
                  style={{ height: "100px" }}
                  onChange={handleDescriptionChange}
                  value={description}
                />
              </FloatingLabel>
              {english ? (
                <FloatingLabel className="mb-3" label="Description">
                  <Form.Control
                    as="textarea"
                    placeholder="Description"
                    style={{ height: "100px" }}
                    onChange={handleDescriptionEnglishChange}
                    value={description_english}
                  />
                </FloatingLabel>
              ) : (
                <></>
              )}
              <Form.Group className="mb-3">
                <Form.Select
                  aria-label="Seleccionar competencia"
                  onChange={handleCompetencyChange}
                  value={competency}
                >
                  {state.language === "en" ? (
                    <option value="">Select competency</option>
                  ) : (
                    <option value="">Seleccionar competencia</option>
                  )}
                  {competencies.map((item) => (
                    <option value={item._id} key={item._id}>
                      {state.language === "en" ? item.name_english : item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Select
                  aria-label="Seleccionar escala"
                  onChange={handleScaleChange}
                  value={scale}
                >
                  {state.language === "en" ? (
                    <option value="">Select scale</option>
                  ) : (
                    <option value="">Seleccionar escala</option>
                  )}

                  {scales.map((item) => (
                    <option value={item._id} key={item._id}>
                      {state.language === "en" ? item.name_english : item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Button className="primary" onClick={handleSubmit}>
                {t("Competencias.Comportamiento.EditForm.Guardar")}
              </Button>
              <Link to="/behaviors">
                <Button className="danger">
                  {t("Competencias.Comportamiento.EditForm.Cancelar")}
                </Button>
              </Link>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default EditBehaviorForm;
